import { FaYoutube } from "react-icons/fa";
import { trackEvent } from "../../shared/helpers/analytics";
export default function YouTubeChannelButton({ scope = "author" }) {
  const handle = scope === "entertainment" ? "@AvwakinEntertainment" : "@AuthorKennethLPowell";
  return <a className="youtubeChannelButton" href={`https://www.youtube.com/${handle}`} onClick={() => { if (scope === "entertainment") trackEvent("entertainment_youtube_click"); }} target="_blank" rel="noopener noreferrer"><FaYoutube aria-hidden="true" />Visit {handle} on YouTube</a>;
}
